const LICENSE_PLATE_PATTERN = new RegExp(
  /^([a-zA-Z]{3})-([0-9]{4})|([a-zA-Z]{3}[0-9][a-zA-Z][0-9]{2})$/
);

const isLicensePlateValid = value => {
  return value && LICENSE_PLATE_PATTERN.test(value);
};

export default isLicensePlateValid;
